// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-wrapper {
    padding-top: 20px;
}
.row {
    justify-content: center;
}

.term-container {
    float: left;
}

.btn-primary {
    float: right;
}`, "",{"version":3,"sources":["webpack://./src/pages/StudentCourse/Confirmation/StudentCourse.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".student-wrapper {\r\n    padding-top: 20px;\r\n}\r\n.row {\r\n    justify-content: center;\r\n}\r\n\r\n.term-container {\r\n    float: left;\r\n}\r\n\r\n.btn-primary {\r\n    float: right;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
